import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
    constructor(public _domSanitizer: DomSanitizer) { }

    public transform(value: string, args: string): SafeHtml {
        switch (args) {
            case 'html':
                return this._domSanitizer.bypassSecurityTrustHtml(value || '');
            case 'style':
                return this._domSanitizer.bypassSecurityTrustStyle(value || '');
            case 'label':
                return this._domSanitizer.bypassSecurityTrustHtml(
                    (value || '').replace(/(<br\s*\/?>\s*)+(<\/(?:p|div|li|h[1-6])>)/gi, '$2')
                );
            default:
                return this._domSanitizer.bypassSecurityTrustHtml(value || '');
        }
    }
}